const menuItemExpertis = document.getElementById('menu-item-319');
const subMenu = document.querySelector('.sub-menu');
subMenu.setAttribute('id', 'main-menu-sub-menu');
let expanded = false;
let imgSrc;

function getWindowWidth() {
  return window.innerWidth;
}

const subMenuToggle = document.createElement('button');
subMenuToggle.setAttribute('id', 'sub-menu-toggle');
subMenuToggle.setAttribute('aria-expanded', `${expanded}`);
subMenuToggle.setAttribute('aria-controlls', 'main-menu-sub-menu');
subMenuToggle.setAttribute('type', 'button');

const menuTriangle = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
menuTriangle.setAttribute('id', 'menu-triangle');
menuTriangle.setAttribute('width', 348);
menuTriangle.setAttribute('height', 225);
menuTriangle.setAttribute('fill', 'none');
menuTriangle.setAttribute('viewBox', '0 0 348 225');
menuTriangle.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
const menuTrianglePath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
menuTrianglePath.setAttribute('id', 'menu-triangle-path');
menuTrianglePath.setAttribute('d', 'M174 225L0.794922 -6.10352e-05L347.205 -3.0751e-05L174 225Z');


const menuArrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
menuArrow.setAttribute('id', 'menu-arrow');
menuArrow.setAttribute('width', 348);
menuArrow.setAttribute('height', 188);
menuArrow.setAttribute('fill', 'none');
menuArrow.setAttribute('viewBox', '0 0 348 188');
menuArrow.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
const menuArrowPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
menuArrowPath.setAttribute('id', 'menu-arrow-path');
menuArrowPath.setAttribute('d', 'M6.68796 6.76352L174 174.075L341.312 6.76352');

subMenuToggle.appendChild(menuTriangle);
subMenuToggle.appendChild(menuArrow);

menuTriangle.appendChild(menuTrianglePath);
menuArrow.appendChild(menuArrowPath);

menuItemExpertis.insertBefore(subMenuToggle, subMenu);

function expandSubMenu() {
	if (expanded) {
		expanded = !expanded;
		menuItemExpertis.removeAttribute('style');
		subMenu.removeAttribute('style');
		menuTriangle.style.transform = 'rotate(0deg)';
	} else {
		expanded = !expanded;
		menuItemExpertis.style.height = 'max-content';
    if (window.innerWidth <= 768) {
      menuItemExpertis.style.backgroundColor = '#3645fd';
      menuItemExpertis.style.color = 'white';
    }
		subMenu.style.display = 'initial';
		subMenu.style.color = '#0a0a0a';
		menuTriangle.style.transform = 'rotate(180deg)';
	}

	subMenuToggle.setAttribute('aria-expanded', `${expanded}`);
}

subMenuToggle.addEventListener('click', expandSubMenu);
subMenu.addEventListener('click', expandSubMenu);
